module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "container",
    staticClass: "scroll_container",
    class: {
      'has-scroll-fx': _vm.store.scrollFx, 'has-virtual-scroll': _vm.store.virtualScroll
    }
  }, [_c('div', {
    ref: "inner",
    staticClass: "scroll_inner"
  }, [_c('section', {
    staticClass: "home"
  }, [_c('header', {
    staticClass: "header section row on-scroll on-scroll--sub",
    attrs: {
      "data-trigger": "{\"header\": true}"
    }
  }, [_c('div', {
    staticClass: "row__side on-scroll__sub"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.top))])]), _vm._v(" "), _c('div', {
    staticClass: "row__main c-primary on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('div', {
    staticClass: "row__main-left"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.db.general.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.db.general.description)
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "projects section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.projects))])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.db.projects), function(project) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('project', {
      key: _vm.updateKey,
      attrs: {
        "project": project
      }
    })], 1)
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.store.isLarge),
      expression: "store.isLarge"
    }],
    staticClass: "projects projects--archives section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.archives))])]), _vm._v(" "), _c('ul', {
    staticClass: "list list--condensed"
  }, _vm._l((_vm.db.archives), function(project) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('project', {
      key: _vm.updateKey,
      attrs: {
        "project": project,
        "type": "archive"
      }
    })], 1)
  }))]), _vm._v(" "), _c('section', {
    staticClass: "about section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.about))])]), _vm._v(" "), _c('div', {
    staticClass: "experience"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.db.experience), function(exp) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "row__side row__side--m-50 on-scroll__sub"
    }, [_c('h3', [_vm._v(_vm._s(exp.date))])]), _vm._v(" "), _c('div', {
      staticClass: "row__main row__main--m-50"
    }, [_c('div', {
      staticClass: "row__main-left on-scroll__sub",
      attrs: {
        "data-scroll": "second"
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(exp.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row__main-right on-scroll__sub",
      attrs: {
        "data-scroll": "third"
      }
    }, [_c('p', [_vm._v(_vm._s(exp.location))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "more section row on-scroll on-scroll--sub"
  }, [_c('div', {
    staticClass: "row__side row__side--m-50 list__item on-scroll__sub"
  }, [_c('ul', {
    staticClass: "list list--condensed"
  }, _vm._l((_vm.db.education), function(ed) {
    return _c('li', {
      staticClass: "list__item list__item--flex"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(ed.date)
      }
    }), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(ed.title))]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(ed.description))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row__main row__main--m-50 row__main--margin"
  }, [_c('div', {
    staticClass: "row__main-left on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('p', {
    staticClass: "list__item",
    domProps: {
      "innerHTML": _vm._s(_vm.db.about)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main-right on-scroll__sub",
    attrs: {
      "data-scroll": "third"
    }
  }, [_c('ul', _vm._l((_vm.db.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.label))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "signature section on-scroll",
    domProps: {
      "innerHTML": _vm._s(_vm.logo)
    }
  })])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.store.showModal) ? _c('modal') : _vm._e()], 1), _vm._v(" "), _c('experiment')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header__tip row__side on-scroll__sub"
  }, [_c('span', [_vm._v("↓")]), _vm._v(" "), _c('small', [_vm._v("scroll")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db253784"}!./src/components/home/home.component.html
// module id = 159
// module chunks = 1